import { Component } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { validateForm } from '@shared/helpers/form.helpers';
import { AuthService } from '../../auth.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { getBackendAuthErrorMessage, getFirebaseAuthErrorMessage } from '../../helpers/auth.helpers';
import { LayoutModule } from '@shared/directives/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
    selector: 'app-login-credentials',
    standalone: true,
    templateUrl: './login-credentials.component.html',
    styleUrl: './login-credentials.component.scss',
    imports: [
        CommonModule, 
        RouterModule, 
        MessageModule, 
        LayoutModule,
        TranslateModule,
        ReactiveFormsModule,
        ButtonModule,
        InputTextModule,
        FloatLabelModule
    ]
})
export class LoginCredentialsComponent {

    getBackendAuthErrorMessage = getBackendAuthErrorMessage;
    getFirebaseAuthErrorMessage = getFirebaseAuthErrorMessage;

    form: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required]),
    })

    get username() {
        return this.form.get('username')
    }

    get password() {
        return this.form.get('password')
    }

    constructor(
        public auth: AuthService,
        private router: Router
    ) { }

    register() {
        this.router.navigate(['register'])
    }

    login() {
        console.log("Login Button Clicked. Form is valid: ", this.form.valid)
        if (this.form.valid) {
            this.auth.login(this.form.value)
        } else {
            validateForm(this.form)
        }
    }


    socialLogin(provider: 'google' | 'facebook' | 'apple') {
        this.auth.socialLogin(provider)
    }

}
